import { useMemo } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import styled from 'styled-components';
import SourceDescriptionIcon from './SourceDescriptionIcon';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSourceLabel = styled.div.withConfig({
  displayName: "SourceLabelSection__StyledSourceLabel",
  componentId: "sc-1e1q4h1-0"
})(["margin-bottom:0 !important;padding-bottom:0 !important;width:fit-content !important;padding-right:2px;"]);
const SourceLabelSection = ({
  label,
  description,
  instance,
  width
}) => {
  const instanceSectionContent = useMemo(() => {
    if (instance && instance.name && instance.relativeUri) return /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx("div", {
        style: {
          maxWidth: `${width}`
        },
        children: /*#__PURE__*/_jsx(Link, {
          truncate: true,
          "data-test-id": "source-interpretation-instance-link",
          href: `${window.location.origin}/${instance.relativeUri}`,
          external: true,
          children: instance.name
        })
      })
    });

    // Instance with name only
    if (instance && instance.name) return /*#__PURE__*/_jsx(Small, {
      "data-test-id": "source-interpretation-instance-name",
      children: /*#__PURE__*/_jsx(TruncateString, {
        maxWidth: width,
        children: instance.name
      })
    });
    return undefined;
  }, [instance, width]);
  const labelSectionContent = useMemo(() => {
    const hasDescription = description !== '';
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "source-interpretation-label",
      className: "align-center",
      children: /*#__PURE__*/_jsx(StyledSourceLabel, {
        children: /*#__PURE__*/_jsx(TruncateString, {
          tooltip: label,
          maxWidth: width,
          useFlex: hasDescription,
          fixedChildren: hasDescription && /*#__PURE__*/_jsx(SourceDescriptionIcon, {
            description: description
          }),
          children: label
        })
      })
    });
  }, [label, width, description]);
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "source-interpretation-section",
    className: "align-center",
    children: /*#__PURE__*/_jsx(StyledSourceLabel, {
      children: /*#__PURE__*/_jsxs(TruncateString, {
        maxWidth: width,
        useFlex: true,
        tooltip: false,
        children: [labelSectionContent, instanceSectionContent]
      })
    })
  });
};
export default SourceLabelSection;